//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client.types';
import { getAxios, getBaseUrl } from './helpers';

export function create(dto: Types.CreateDataBlockDto, config?: AxiosRequestConfig | undefined): Promise<Types.DataBlockWithValuesDto> {
    let url_ = getBaseUrl() + "/api/data-blocks";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeCreateDataBlockDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigCreate,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigCreate?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCreate(_response);
    });
}

function processCreate(response: AxiosResponse): Promise<Types.DataBlockWithValuesDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initDataBlockWithValuesDto(resultData200);
        return Promise.resolve<Types.DataBlockWithValuesDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.DataBlockWithValuesDto>(null as any);
}

/**
 * Returns DataBlocks WITHOUT `Values` included (so that response is shorter).
If you want `Values`, please use GetWithValues.
You could filter by `Values` like that:
- /api/data-blocks?values[AHI]=17
- /api/data-blocks?values[AHI__gt]=10 (greater than)
- /api/data-blocks?values[AHI__lt]=20 (less than)
- /api/data-blocks?values[AHI__ge]=17 (greater or equal)
- /api/data-blocks?values[AHI__le]=17 (less or equal)
- /api/data-blocks?values[comment__in]=substring (comment value includes 'substring')
- /api/data-blocks?values[AHI]=20&values[AHI]=21 (AHI is 20 or 21)
 * @param patientId (optional) 
 * @param caseId (optional) 
 * @param visitId (optional) 
 * @param visitIds (optional) 
 * @param caseIds (optional) 
 * @param variant (optional) 
 * @param typeId (optional) 
 * @param importIds (optional) 
 * @param values (optional) Example:
?values[f1__gr]=1&values[f1__le]=123&values[f2]=value.
Key is field name, IList<string> contain values. It's an IList because we support multiple values for 'eq' condition
See https://dev.azure.com/prismacode/Unicorn/_wiki/wikis/Unicorn.wiki/1490/DataBlocks-API for more details
 * @param begin (optional) 
 * @param pagination_Offset (optional) 
 * @param pagination_Limit (optional) 
 * @param sorting_SortField (optional) 
 * @param sorting_SortDirection (optional) 
 * @param additionalSorting (optional) 
 */
export function get(patientId?: number | null | undefined, caseId?: number | null | undefined, visitId?: number | null | undefined, visitIds?: number[] | null | undefined, caseIds?: number[] | null | undefined, variant?: Types.DataBlockVariant | null | undefined, typeId?: number | null | undefined, importIds?: string[] | null | undefined, values?: { [key: string]: string[]; } | null | undefined, begin?: Date | null | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.PageableListDtoOfDataBlockDto> {
    let url_ = getBaseUrl() + "/api/data-blocks?";
    if (patientId !== undefined && patientId !== null)
        url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
    if (caseId !== undefined && caseId !== null)
        url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
    if (visitId !== undefined && visitId !== null)
        url_ += "VisitId=" + encodeURIComponent("" + visitId) + "&";
    if (visitIds !== undefined && visitIds !== null)
        visitIds && visitIds.forEach(item => { url_ += "VisitIds=" + encodeURIComponent("" + item) + "&"; });
    if (caseIds !== undefined && caseIds !== null)
        caseIds && caseIds.forEach(item => { url_ += "CaseIds=" + encodeURIComponent("" + item) + "&"; });
    if (variant !== undefined && variant !== null)
        url_ += "Variant=" + encodeURIComponent("" + variant) + "&";
    if (typeId !== undefined && typeId !== null)
        url_ += "TypeId=" + encodeURIComponent("" + typeId) + "&";
    if (importIds !== undefined && importIds !== null)
        importIds && importIds.forEach(item => { url_ += "ImportIds=" + encodeURIComponent("" + item) + "&"; });
    if (values !== undefined && values !== null)
        values && Object.keys(values).forEach(key => { url_ += encodeURIComponent(key) +"=" + encodeURIComponent("" + values[key]) + "&"; });
    if (begin !== undefined && begin !== null)
        url_ += "Begin=" + encodeURIComponent(begin ? "" + begin.toISOString() : "") + "&";
    if (pagination_Offset === null)
        throw new Error("The parameter 'pagination_Offset' cannot be null.");
    else if (pagination_Offset !== undefined)
        url_ += "Pagination.Offset=" + encodeURIComponent("" + pagination_Offset) + "&";
    if (pagination_Limit === null)
        throw new Error("The parameter 'pagination_Limit' cannot be null.");
    else if (pagination_Limit !== undefined)
        url_ += "Pagination.Limit=" + encodeURIComponent("" + pagination_Limit) + "&";
    if (sorting_SortField !== undefined && sorting_SortField !== null)
        url_ += "Sorting.SortField=" + encodeURIComponent("" + sorting_SortField) + "&";
    if (sorting_SortDirection === null)
        throw new Error("The parameter 'sorting_SortDirection' cannot be null.");
    else if (sorting_SortDirection !== undefined)
        url_ += "Sorting.SortDirection=" + encodeURIComponent("" + sorting_SortDirection) + "&";
    if (additionalSorting !== undefined && additionalSorting !== null)
        additionalSorting && additionalSorting.forEach((item, index) => {
            for (let attr in item)
    			if (item.hasOwnProperty(attr)) {
    				url_ += "AdditionalSorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
    			}
        });
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGet,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGet?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGet(_response);
    });
}

function processGet(response: AxiosResponse): Promise<Types.PageableListDtoOfDataBlockDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initPageableListDtoOfDataBlockDto(resultData200);
        return Promise.resolve<Types.PageableListDtoOfDataBlockDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PageableListDtoOfDataBlockDto>(null as any);
}

export function import_(dto: Types.CreateDataBlockDto, config?: AxiosRequestConfig | undefined): Promise<Types.DataBlockWithValuesDto> {
    let url_ = getBaseUrl() + "/api/data-blocks/device-measurements";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeCreateDataBlockDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigImport,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigImport?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processImport(_response);
    });
}

function processImport(response: AxiosResponse): Promise<Types.DataBlockWithValuesDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initDataBlockWithValuesDto(resultData200);
        return Promise.resolve<Types.DataBlockWithValuesDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.DataBlockWithValuesDto>(null as any);
}

export function reImportSingleMeasurement(id: number, dto: Types.ReImportMeasurementDto, config?: AxiosRequestConfig | undefined): Promise<Types.DataBlockWithValuesDto> {
    let url_ = getBaseUrl() + "/api/data-blocks/device-measurements/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeReImportMeasurementDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigReImportSingleMeasurement,
        ...config,
        data: content_,
        method: "PUT",
        url: url_,
        headers: {
            ..._requestConfigReImportSingleMeasurement?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processReImportSingleMeasurement(_response);
    });
}

function processReImportSingleMeasurement(response: AxiosResponse): Promise<Types.DataBlockWithValuesDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initDataBlockWithValuesDto(resultData200);
        return Promise.resolve<Types.DataBlockWithValuesDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.DataBlockWithValuesDto>(null as any);
}

export function startReimport(config?: AxiosRequestConfig | undefined): Promise<string> {
    let url_ = getBaseUrl() + "/api/data-blocks/device-measurements/reimport";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigStartReimport,
        ...config,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigStartReimport?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processStartReimport(_response);
    });
}

function processStartReimport(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
    
        result200 = resultData200;
    
        return Promise.resolve<string>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<string>(null as any);
}

export function getReimportResult(processId: string, config?: AxiosRequestConfig | undefined): Promise<Types.ReimportResultDto> {
    let url_ = getBaseUrl() + "/api/data-blocks/device-measurements/reimport/{processId}";
    if (processId === undefined || processId === null)
      throw new Error("The parameter 'processId' must be defined.");
    url_ = url_.replace("{processId}", encodeURIComponent("" + processId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetReimportResult,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetReimportResult?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetReimportResult(_response);
    });
}

function processGetReimportResult(response: AxiosResponse): Promise<Types.ReimportResultDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initReimportResultDto(resultData200);
        return Promise.resolve<Types.ReimportResultDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.ReimportResultDto>(null as any);
}

/**
 * Returns DataBlocks with `Values` included
You could filter by `Values` like that:
/api/data-blocks?values[AHI]=17
/api/data-blocks?values[AHI__gt]=10 (greater than)
/api/data-blocks?values[AHI__lt]=20 (less than)
/api/data-blocks?values[AHI__ge]=17 (greater or equal)
/api/data-blocks?values[AHI__le]=17 (less or equal)
/api/data-blocks?values[comment__in]=substring (comment value includes 'substring')
/api/data-blocks?values[AHI]=20&values[AHI]=21 (AHI is 20 or 21)
 * @param patientId (optional) 
 * @param caseId (optional) 
 * @param visitId (optional) 
 * @param visitIds (optional) 
 * @param caseIds (optional) 
 * @param variant (optional) 
 * @param typeId (optional) 
 * @param importIds (optional) 
 * @param values (optional) Example:
?values[f1__gr]=1&values[f1__le]=123&values[f2]=value.
Key is field name, IList<string> contain values. It's an IList because we support multiple values for 'eq' condition
See https://dev.azure.com/prismacode/Unicorn/_wiki/wikis/Unicorn.wiki/1490/DataBlocks-API for more details
 * @param begin (optional) 
 * @param pagination_Offset (optional) 
 * @param pagination_Limit (optional) 
 * @param sorting_SortField (optional) 
 * @param sorting_SortDirection (optional) 
 * @param additionalSorting (optional) 
 */
export function getWithValues(patientId?: number | null | undefined, caseId?: number | null | undefined, visitId?: number | null | undefined, visitIds?: number[] | null | undefined, caseIds?: number[] | null | undefined, variant?: Types.DataBlockVariant | null | undefined, typeId?: number | null | undefined, importIds?: string[] | null | undefined, values?: { [key: string]: string[]; } | null | undefined, begin?: Date | null | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.PageableListDtoOfDataBlockWithValuesDto> {
    let url_ = getBaseUrl() + "/api/data-blocks/with-values?";
    if (patientId !== undefined && patientId !== null)
        url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
    if (caseId !== undefined && caseId !== null)
        url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
    if (visitId !== undefined && visitId !== null)
        url_ += "VisitId=" + encodeURIComponent("" + visitId) + "&";
    if (visitIds !== undefined && visitIds !== null)
        visitIds && visitIds.forEach(item => { url_ += "VisitIds=" + encodeURIComponent("" + item) + "&"; });
    if (caseIds !== undefined && caseIds !== null)
        caseIds && caseIds.forEach(item => { url_ += "CaseIds=" + encodeURIComponent("" + item) + "&"; });
    if (variant !== undefined && variant !== null)
        url_ += "Variant=" + encodeURIComponent("" + variant) + "&";
    if (typeId !== undefined && typeId !== null)
        url_ += "TypeId=" + encodeURIComponent("" + typeId) + "&";
    if (importIds !== undefined && importIds !== null)
        importIds && importIds.forEach(item => { url_ += "ImportIds=" + encodeURIComponent("" + item) + "&"; });
    if (values !== undefined && values !== null)
        values && Object.keys(values).forEach(key => { url_ += encodeURIComponent(key) +"=" + encodeURIComponent("" + values[key]) + "&"; });
    if (begin !== undefined && begin !== null)
        url_ += "Begin=" + encodeURIComponent(begin ? "" + begin.toISOString() : "") + "&";
    if (pagination_Offset === null)
        throw new Error("The parameter 'pagination_Offset' cannot be null.");
    else if (pagination_Offset !== undefined)
        url_ += "Pagination.Offset=" + encodeURIComponent("" + pagination_Offset) + "&";
    if (pagination_Limit === null)
        throw new Error("The parameter 'pagination_Limit' cannot be null.");
    else if (pagination_Limit !== undefined)
        url_ += "Pagination.Limit=" + encodeURIComponent("" + pagination_Limit) + "&";
    if (sorting_SortField !== undefined && sorting_SortField !== null)
        url_ += "Sorting.SortField=" + encodeURIComponent("" + sorting_SortField) + "&";
    if (sorting_SortDirection === null)
        throw new Error("The parameter 'sorting_SortDirection' cannot be null.");
    else if (sorting_SortDirection !== undefined)
        url_ += "Sorting.SortDirection=" + encodeURIComponent("" + sorting_SortDirection) + "&";
    if (additionalSorting !== undefined && additionalSorting !== null)
        additionalSorting && additionalSorting.forEach((item, index) => {
            for (let attr in item)
    			if (item.hasOwnProperty(attr)) {
    				url_ += "AdditionalSorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
    			}
        });
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetWithValues,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetWithValues?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetWithValues(_response);
    });
}

function processGetWithValues(response: AxiosResponse): Promise<Types.PageableListDtoOfDataBlockWithValuesDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initPageableListDtoOfDataBlockWithValuesDto(resultData200);
        return Promise.resolve<Types.PageableListDtoOfDataBlockWithValuesDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PageableListDtoOfDataBlockWithValuesDto>(null as any);
}

export function getDataBlock(id: number, config?: AxiosRequestConfig | undefined): Promise<Types.DataBlockWithValuesDto> {
    let url_ = getBaseUrl() + "/api/data-blocks/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetDataBlock,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetDataBlock?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetDataBlock(_response);
    });
}

function processGetDataBlock(response: AxiosResponse): Promise<Types.DataBlockWithValuesDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initDataBlockWithValuesDto(resultData200);
        return Promise.resolve<Types.DataBlockWithValuesDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.DataBlockWithValuesDto>(null as any);
}

export function edit(id: number, dto: Types.UpdateDataBlockDto, config?: AxiosRequestConfig | undefined): Promise<Types.DataBlockWithValuesDto> {
    let url_ = getBaseUrl() + "/api/data-blocks/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeUpdateDataBlockDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigEdit,
        ...config,
        data: content_,
        method: "PUT",
        url: url_,
        headers: {
            ..._requestConfigEdit?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processEdit(_response);
    });
}

function processEdit(response: AxiosResponse): Promise<Types.DataBlockWithValuesDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initDataBlockWithValuesDto(resultData200);
        return Promise.resolve<Types.DataBlockWithValuesDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.DataBlockWithValuesDto>(null as any);
}

export function remove(id: number, dto: Types.RemoveDataBlockDto, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/data-blocks/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeRemoveDataBlockDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigRemove,
        ...config,
        data: content_,
        method: "DELETE",
        url: url_,
        headers: {
            ..._requestConfigRemove?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processRemove(_response);
    });
}

function processRemove(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}
let _requestConfigCreate: Partial<AxiosRequestConfig> | null;
export function getCreateRequestConfig() {
  return _requestConfigCreate;
}
export function setCreateRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCreate = value;
}
export function patchCreateRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCreate = patch(_requestConfigCreate ?? {});
}

let _requestConfigGet: Partial<AxiosRequestConfig> | null;
export function getGetRequestConfig() {
  return _requestConfigGet;
}
export function setGetRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGet = value;
}
export function patchGetRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGet = patch(_requestConfigGet ?? {});
}

let _requestConfigImport: Partial<AxiosRequestConfig> | null;
export function getImportRequestConfig() {
  return _requestConfigImport;
}
export function setImportRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigImport = value;
}
export function patchImportRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigImport = patch(_requestConfigImport ?? {});
}

let _requestConfigReImportSingleMeasurement: Partial<AxiosRequestConfig> | null;
export function getReImportSingleMeasurementRequestConfig() {
  return _requestConfigReImportSingleMeasurement;
}
export function setReImportSingleMeasurementRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigReImportSingleMeasurement = value;
}
export function patchReImportSingleMeasurementRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigReImportSingleMeasurement = patch(_requestConfigReImportSingleMeasurement ?? {});
}

let _requestConfigStartReimport: Partial<AxiosRequestConfig> | null;
export function getStartReimportRequestConfig() {
  return _requestConfigStartReimport;
}
export function setStartReimportRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigStartReimport = value;
}
export function patchStartReimportRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigStartReimport = patch(_requestConfigStartReimport ?? {});
}

let _requestConfigGetReimportResult: Partial<AxiosRequestConfig> | null;
export function getGetReimportResultRequestConfig() {
  return _requestConfigGetReimportResult;
}
export function setGetReimportResultRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetReimportResult = value;
}
export function patchGetReimportResultRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetReimportResult = patch(_requestConfigGetReimportResult ?? {});
}

let _requestConfigGetWithValues: Partial<AxiosRequestConfig> | null;
export function getGetWithValuesRequestConfig() {
  return _requestConfigGetWithValues;
}
export function setGetWithValuesRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetWithValues = value;
}
export function patchGetWithValuesRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetWithValues = patch(_requestConfigGetWithValues ?? {});
}

let _requestConfigGetDataBlock: Partial<AxiosRequestConfig> | null;
export function getGetDataBlockRequestConfig() {
  return _requestConfigGetDataBlock;
}
export function setGetDataBlockRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetDataBlock = value;
}
export function patchGetDataBlockRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetDataBlock = patch(_requestConfigGetDataBlock ?? {});
}

let _requestConfigEdit: Partial<AxiosRequestConfig> | null;
export function getEditRequestConfig() {
  return _requestConfigEdit;
}
export function setEditRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigEdit = value;
}
export function patchEditRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigEdit = patch(_requestConfigEdit ?? {});
}

let _requestConfigRemove: Partial<AxiosRequestConfig> | null;
export function getRemoveRequestConfig() {
  return _requestConfigRemove;
}
export function setRemoveRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigRemove = value;
}
export function patchRemoveRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigRemove = patch(_requestConfigRemove ?? {});
}